"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainflexSerieImport = exports.ChainflexSerieImportSchema = void 0;
const tslib_1 = require("tslib");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const zod_1 = require("zod");
const AccelerationUnitSchema_1 = tslib_1.__importDefault(require("../../generated/zod/inputTypeSchemas/AccelerationUnitSchema"));
const LengthUnitSchema_1 = tslib_1.__importDefault(require("../../generated/zod/inputTypeSchemas/LengthUnitSchema"));
const VelocityUnitSchema_1 = tslib_1.__importDefault(require("../../generated/zod/inputTypeSchemas/VelocityUnitSchema"));
const ChainflexSeriesSchema_1 = require("../../generated/zod/modelSchema/ChainflexSeriesSchema");
const Mantelwerkstoff_1 = require("../Mantelwerkstoff");
const OelBestaendigkeit_1 = require("../OelBestaendigkeit");
const checkMissingProps = (condition, props, value, msg, ctx) => {
    if (!condition) {
        return true;
    }
    const missingProps = props.filter((prop) => !value[prop]);
    if (!missingProps.length) {
        return true;
    }
    missingProps.forEach((prop) => {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: [prop],
            message: `missing although "${msg}" is set`,
            fatal: true,
        });
    });
    return false;
};
exports.ChainflexSerieImportSchema = ChainflexSeriesSchema_1.ChainflexSeriesSchema.extend({
    description: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    speedMaxUnsupportedUnit: VelocityUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxUnsupportedUnit: AccelerationUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceUnsupportedUnit: LengthUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxGlidingUnit: VelocityUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxGlidingUnit: AccelerationUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceGlidingUnit: LengthUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxVerticalUnit: VelocityUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxVerticalUnit: AccelerationUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceVerticalUnit: LengthUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxUnsupported: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxUnsupported: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceUnsupported: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxGliding: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxGliding: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceGliding: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    speedMaxVertical: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    accelerationMaxVertical: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    travelDistanceVertical: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    outerJacket: zod_1.z.custom(Mantelwerkstoff_1.isMantelwerkstoff, { message: 'invalid Mantelwerkstoff' }),
    oilResistant: zod_1.z
        .string()
        .min(1)
        .and(zod_1.z.custom(OelBestaendigkeit_1.isOelBestaendigkeit, { message: 'invalid OelBestaendigkeit' })),
}).superRefine((value, ctx) => {
    const conditions = [
        {
            condition: value.unsupportedAllowed && !value.categories.includes(echain_prisma_client_1.ChainflexCategory.PullWires),
            props: [
                'accelerationMaxUnsupported',
                'accelerationMaxUnsupportedUnit',
                'speedMaxUnsupported',
                'speedMaxUnsupportedUnit',
                'travelDistanceUnsupported',
                'travelDistanceUnsupportedUnit',
            ],
            msg: 'unsupportedAllowed',
        },
        {
            condition: value.glidingAllowed && !value.categories.includes(echain_prisma_client_1.ChainflexCategory.PullWires),
            props: [
                'accelerationMaxGliding',
                'accelerationMaxGlidingUnit',
                'speedMaxGliding',
                'speedMaxGlidingUnit',
                'travelDistanceGliding',
                'travelDistanceGlidingUnit',
            ],
            msg: 'glidingAllowed',
        },
        {
            condition: value.verticalAllowed && !value.categories.includes(echain_prisma_client_1.ChainflexCategory.PullWires),
            props: [
                'accelerationMaxVertical',
                'accelerationMaxVerticalUnit',
                'speedMaxVertical',
                'speedMaxVerticalUnit',
                'travelDistanceVertical',
                'travelDistanceVerticalUnit',
            ],
            msg: 'verticalAllowed',
        },
    ];
    return conditions.every(({ condition, props, msg }) => checkMissingProps(condition, props, value, msg, ctx));
});
const isChainflexSerieImport = (whatever) => {
    var _a;
    return (_a = exports.ChainflexSerieImportSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isChainflexSerieImport = isChainflexSerieImport;
//# sourceMappingURL=ChainflexSerieImport.js.map